export default {  
  generalSettings: {},
  cache: {
    generalSettingsLoaded: false
  }

}
